import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNdd70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_70: Record<
  Exclude<PageIdWoofzNdd70, PageIdWoofzNdd70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NDD_70]: {
    id: PageId.SUBSCRIPTIONS_NDD_70,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NDD_70]: {
    id: PageId.CHAT_UPSELL_NDD_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NDD_70]: {
    id: PageId.UPSELL_NDD_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NDD_70]: {
    id: PageId.DOWNLOAD_NDD_70,
    theme: THEMES.POLICY,
    hasHeader: true,
  },
}
